module.exports = __webpack_public_path__ + "static/media/position.3113a5ad.svg";